// extracted by mini-css-extract-plugin
export default {"schedule":"TutorScheduleWeeklyLesson_schedule__rSpSn"};